import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cm-html-content',
  templateUrl: './html-content.component.html',
  styleUrls: ['./html-content.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class HtmlContentComponent implements OnInit {
  @Input() innerHTML: string = '';

  constructor() {}

  ngOnInit(): void {}

  checkIfHtmlSet(): boolean {
    return this.innerHTML !== '';
  }
}
